/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ConfirmTriggeredActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {ConfirmTriggeredActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const confirmTriggeredAction = (request: ConfirmTriggeredActionRequest, options?: CashRequestOptions) => post<ConfirmTriggeredActionRequest, ConfirmTriggeredActionResponse>("/2.0/cash/confirm-triggered-action", request, {...options, rejectOnError: true })